import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

interface StatusItem {
  label: string;
  count: number;
  statusCode?: string;
  color_text?: string;
  color_bg?: string;
  color_progress?: string;
}

@Component({
  selector: 'app-player-stats-bar',
  templateUrl: './player-stats-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PlayerStatsBarComponent {
  @Input() total: number = 0;
  @Input() totalHommes: number = 0;
  @Input() totalFemmes: number = 0;
  @Input() statusItems: StatusItem[] = [];
  @Input() isLoading: boolean = false;
  @Input() entityLabel: string = 'Joueurs';
  @Input() showGender: boolean = true;

  dotColor(item: StatusItem): string {
    return item.color_text || '#a8a29e';
  }

  textColor(item: StatusItem): string {
    return item.color_text || '#78716c';
  }

  barColor(item: StatusItem): string {
    return item.color_text || '#a8a29e';
  }

  pct(count: number): string {
    return this.total ? (count / this.total * 100).toFixed(1) + '%' : '0%';
  }

  hommePct(): string {
    return this.total ? Math.round(this.totalHommes / this.total * 100) + '%' : '0%';
  }

  femmePct(): string {
    return this.total ? Math.round(this.totalFemmes / this.total * 100) + '%' : '0%';
  }
}
